  <div class="sb-step sb-step-shipping-method">
  <form class="sb-step__form" [formGroup]="partialIccidForm">

    <!-- region Step container -->
    <div class="sb-step__form__content" *ngIf="!shouldShowCamera">
      <div class="sb-step__inner-container">
        <!-- <sb-promo-banner></sb-promo-banner> -->
        <div class="sb-form-block">
          <div class="sb-form-block__title">
            {{'ENTITY.FDO-ICCID.TITLE' | translate}}
          </div>
          <div class="row">
            <ng-container *ngIf="cameraEnabled">
              <div class="col-md-4 col-md-offset-0 col-sm-5 col-sm-offset-0 col-xs-10 col-xs-offset-1 input-box-complex">
                <label class="label-input-placeholder">{{ICCID_PREFIX}}</label>
                <wt-input-text [validateOnBlur]="true"
                 [type]="'numeric'"
                 class="flex__input iccid-input-with-placeholder"
                 [maxLength]="FormConstants.MAXIMUM_ICCID_LENGTH_NOPREFIX"
                 [label]="'ENTITY.FDO-ICCID.ICCID' | translate"
                 formControlName="fakeIccid"
                 (ngModelChange)="onInputChange($event)"
                 (focusout)="onInputFocusOut()"
                 ></wt-input-text>
                 <span *ngIf="iccidlength" class="iccidlength">L’ICCID deve avere 19 cifre</span>
              </div>
              <div class="col-md-4 col-sm-2 col-xs-12 wt-text-align-center alternate-element">
                <div class="wt-text-base-l sb-color-grey-dark">oppure</div>
              </div>
              <div class="col-md-4 col-md-offset-0 col-sm-5 col-sm-offset-0 col-xs-10 col-xs-offset-1">
                <div class="wt-margin-top-2">
                  <wt-button [cssClasses]="['wt-button--inverse']" (click)="goToCamera()">
                    <span class="show-if-mobile">{{(hasAlreadyShownCamera ? 'ENTITY.FDO-ICCID.TAKE_PICTURE_AGAIN' : 'ENTITY.FDO-ICCID.TAKE_PICTURE') | translate}}</span>
                    <span class="show-if-desktop">{{(hasAlreadyShownCamera ? 'ENTITY.FDO-ICCID.LOAD_PICTURE_AGAIN' : 'ENTITY.FDO-ICCID.LOAD_PICTURE') | translate}}</span>
                  </wt-button>
                  <input type="file" accept="image/*" id="capture" (change)="onSelectImage()" capture="camera" style="display: none;">
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="!cameraEnabled">
              <div class="col-md-4 col-md-offset-4 col-sm-5 col-sm-offset-0 col-xs-10 col-xs-offset-1">
                <wt-input-text [validateOnBlur]="true" class="flex__input" [maxLength]="FormConstants.MAXIMUM_ICCID_LENGTH" [label]="'ENTITY.ACTIVATION-MNP-INFO.ICCID' | translate" formControlName="iccid"></wt-input-text>
              </div>
            </ng-container>
          </div>
          <div class="wt-text-align-center wt-margin-top-4">
            <!--<div class="wt-margin-bottom-6 wt-margin-top-6">{{'ENTITY.FDO-ICCID.SUBTITLE' | translate}}</div>-->
            <img class="info-image" src="/assets/images/card-iccid.png" alt="" >
          </div>
        </div>
      </div>
    </div>
    <div class="sb-step__form__content" *ngIf="shouldShowCamera">
      <div class="sb-step__inner-container">
        <div class="sb-form-block" formGroupName="fdoIccid">
          <div class="sb-form-block__title wt-text-align-center">
            {{'ENTITY.FDO-ICCID.TAKE_PICTURE_TITLE' | translate}}
          </div>
          <div class="row">
            <div class="photo-box  hidden">
              <div class="camera">
                <video id="video">Video stream not available.</video>
              </div>
              <canvas id="canvas">
              </canvas>
              <div class="output hidden">
                <img id="photo" alt="The screen capture will appear in this box.">
              </div>
            </div>
          </div>

          <div class="wt-text-align-center">
            <div class="wt-margin-bottom-6 wt-margin-top-6 wt-text-base-s" [innerHTML]="'ENTITY.FDO-ICCID.TAKE_PICTURE_HELP' | translate"></div>
          </div>
          <div class="row">
            <div class="col-xs-6 col-xs-offset-3 col-md-4 col-md-offset-4">
              <wt-button id="startbutton" [cssClasses]="'wt-button--inverse'">{{'ENTITY.FDO-ICCID.TAKE_PICTURE' | translate}}</wt-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- endregion -->
    <!-- region Buttons -->
    <section class="sb-step__form__footer">
      <sb-navigation-buttons [isSticky]="shouldBeSticky" [submitDisabled]="this.formGroup.invalid || shouldShowCamera" (backClick)="goToPreviousStep()" (submitClick)="goToNextStep()"></sb-navigation-buttons>
    </section>
    <!-- endregion -->
  </form>
</div>
